import { Fragment } from "react";

import { makeStyles } from "@mui/styles";
import { FormattedMessage } from "react-intl";

import { trackHelpIcon } from "@/shared/services/mixpanel";

import { HelpIcon } from "../../../../shared/icons/navbar/HelpIcon";
import { HelpMenu } from "../HelpMenu/HelpMenu";
import { MainMenu } from "../MainMenu/MainMenu";
import { ToolsMenuControl } from "../ToolsMenuControl/ToolsMenuControl";
import { UserAvatar } from "../UserAvatar/UserAvatar";
import UserMenu from "../UserMenu/UserMenu";

import { type NavbarNgProps } from "../../navbar.types";

type Props = {
  ngProps: NavbarNgProps;
  onImpersonationToggle: () => void;
};

const DesktopMenu = ({ ngProps, onImpersonationToggle }: Props) => {
  const classes = useStyles();
  const { farm, langId, user } = ngProps;

  return (
    <Fragment>
      <MainMenu countryCode={farm.countryCode} farmId={farm.id} />
      <div className={classes.toolbar}>
        <ToolsMenuControl
          buttonId="desktop-help-menu"
          icon={<HelpIcon style={{ width: 28, height: 28 }} />}
          onClick={trackHelpIcon}
          tooltipMessage={<FormattedMessage id="DesktopMenu.help" />}
        >
          {({ onMenuItemClick }) => (
            <HelpMenu langId={langId} onMenuItemClick={onMenuItemClick} />
          )}
        </ToolsMenuControl>
        <ToolsMenuControl
          buttonId="desktop-user-menu"
          icon={<UserAvatar user={user} />}
          tooltipMessage={<FormattedMessage id="DesktopMenu.user" />}
        >
          {({ onMenuItemClick, updatePosition }) => (
            <UserMenu
              ngProps={ngProps}
              onImpersonationToggle={onImpersonationToggle}
              onMenuItemClick={onMenuItemClick}
              updatePosition={updatePosition}
            />
          )}
        </ToolsMenuControl>
      </div>
    </Fragment>
  );
};

const useStyles = makeStyles({
  toolbar: {
    display: "flex",
    height: "100%",
    marginLeft: 5,
    marginRight: 10,
  },
});

export { DesktopMenu };
